<!--
 * @Author: Scarlett Xiao
 * @Date: 2022-01-04 15:05:32
 * @LastEditors: lishiqiao
 * @LastEditTime: 2023-09-19 16:34:45
-->
<template>
  <!-- 育苗 -->
  <div class="content-wrap">
    <div class="page-list">
      <div class="page-type-switch">
        <div class="type-activite">饲料投喂记录</div>
      </div>
      <div class="page-list">
        <!-- 搜索栏 -->
        <div class="page-search-content" ref="searchBox">
          <div class="page-big-box">
            <div class="page-search-item">
              <label>养殖场&nbsp;:</label>
              <el-select v-model="params.params.baseId" filterable placeholder="请选择养殖场" @change="getGroups()">
                <el-option v-for="item in baseList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="page-search-item">
              <label>养殖分组&nbsp;:</label>
              <el-select v-model="params.params.groupId" filterable placeholder="请选择养殖分组" @change="getBoxs()">
                <el-option label="全部养殖分组" value=""></el-option>
                <el-option v-for="item in groupList" :key="item.id" :label="item.groupName" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="page-search-item">
              <label>养殖单元&nbsp;:</label>
              <el-select v-model="params.params.boxId" filterable placeholder="请选择养殖单元">
                <el-option label="全部养殖单元" value=""></el-option>
                <el-option v-for="item in boxList" :key="item.id" :label="item.boxCode" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="page-search-item">
              <label>饲料品类&nbsp;:</label>
              <el-select v-model="params.params.categoryId" filterable placeholder="请选择饲料品类">
                <el-option label="全部饲料品类" value=""></el-option>
                <el-option v-for="item in categoryList" :key="item.id" :label="item.typeName" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="page-search-item">
              <label>投喂时间&nbsp;:</label>
              <el-date-picker v-model="dateRange" value-format="yyyy-MM-dd" @change="dateChange" type="daterange"
                range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
            </div>
            <div class="page-search-item">
              <label>饲料名称&nbsp;:</label>
              <el-select v-model="params.params.fodderId" filterable placeholder="请选择饲料名称">
                <el-option label="全部饲料名称" value=""></el-option>
                <el-option v-for="item in fodderList" :key="item.id" :label="item.fodderName" :value="item.id">
                </el-option>
              </el-select>
            </div>

            <div class="page-search-item">
              <label>记录状态&nbsp;:</label>
              <el-select v-model="params.params.status" placeholder="请选择记录状态">
                <el-option label="全部记录状态" value=""></el-option>
                <el-option v-for="item in reviewStatusList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="page-search-item">
              <label>汇总类型&nbsp;:</label>
              <el-select v-model="params.params.groupType" placeholder="请选择汇总类型">
                <el-option label="全部汇总类型" value=""></el-option>
                <el-option v-for="item in groupTypeList" :key="item.typeId" :label="item.typeName" :value="item.typeId">
                </el-option>
              </el-select>
            </div>
          </div>
          <!-- 按钮 -->
          <div class="page-search-btn">
            <div class="search-btn" @click="search">查询</div>
            <div class="reset-btn" @click="reset">重置</div>
            <div class="search-close-btn">
              <div @click="PageSearchClose" v-if="PageDisplay">
                <span>收起</span><i class="iconfont icon-a-List-Expand"></i>
              </div>
              <div @click="PageSearchOn" v-else>
                <span>展开</span><i class="iconfont icon-List-Collapse"></i>
              </div>
            </div>
          </div>
        </div>
        <!-- 分割线 -->
        <hr class="ufish-split-line" />
        <!-- 图表 -->
        <div v-show="showStatistical" class="charts-content">
          <div class="navigation_tags">
            <div class="label-type">
              <span v-bind:class="{ btn_selected: isNumberChart == '0' }" @click="toggleChartBtn('0')">投喂数量统计</span>
              <span v-bind:class="{ btn_selected: isNumberChart == '1' }" @click="toggleChartBtn('1')">投喂金额统计</span>
              <span v-bind:class="{ btn_selected: isNumberChart == '2' }" @click="toggleChartBtn('2')">投喂品类统计</span>
            </div>
            <div style="display: flex;
                justify-content: flex-end;
                align-items: center;
              ">
              <ul style="margin-right: 50px">
                <li>
                  <span class="chart_text" v-for="(legend, i) in hintFodderData" :key="i"><span class="chart_icon"
                      v-bind:style="{ 'background-color': legend.color }"></span>{{ legend.shortName }}</span>
                </li>
              </ul>
              <div>
                <el-select class="chart-search-item" multiple collapse-tags placeholder="请选择饲料名称" v-model="showFodderData"
                  @change="selectFodder()">
                  <el-option v-for="item in allFodderData" :key="item.fodderId" :label="item.shortName"
                    :value="item.fodderId">
                    <span style="
                        float: left;
                        position: relative;
                        padding-left: 15px;
                      "><i style="
                          position: absolute;
                          width: 6px;
                          height: 6px;
                          top: 14px;
                          left: 0px;
                          border-radius: 2px;
                        " v-bind:style="{ 'background-color': item.color }"></i>{{ item.shortName }}</span>
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="charts_info">
            <div style="height: 100%; width: 100%" id="fodder-charts"></div>
          </div>
        </div>
        <div style="
            display: flex;
            justify-content: center;
            padding: 15px;
            background: #fff;
          ">
          <p class="show-charts-btn" @click="showStatistical = !showStatistical">
            {{ showStatistical ? "收起统计折线图" : "展开统计折线图"
            }}<i v-bind:class="showStatistical
    ? 'iconfont icon-a-List-Expand'
    : 'iconfont icon-List-Collapse'
  "></i>
          </p>
        </div>

        <!-- 内容 -->
        <div class="page-list-content" style="overflow: auto !important;">
          <!-- 列表 -->
          <div class="page-list-title">
            <div><i class="title-icon"></i>饲料投喂记录</div>
            <div>单位: {{ orgName }}</div>
            <div class="page-list-btns">
              <!-- 暂时去掉按钮 -->
              <!-- <span class="switch-table" @click="download">模板下载</span>
              <FileUpload class="switch-table" :url="fileupload"
                >导入报表</FileUpload
              > -->
              <el-dropdown style="margin-right: 30px;" @command="setFixedColumn">
                <span class="el-dropdown-link">
                  冻结列<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="y">冻结至"{{
                    fixedColumn.label
                  }}"列</el-dropdown-item>
                  <el-dropdown-item command="n">取消冻结</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <span @click="exportTable">
                <i class="title-export-btn iconfont icon-a-List-Export"></i>导出报表
              </span>
            </div>
          </div>
          <!-- 表格 -->
          <el-table :data="feedstuffFeedingList" :max-height="tableHeight" row-key="id" border style="width: 100%"
            :row-class-name="tableRowClassName" @header-click="handleClick">
            <el-table-column :fixed="fixedColumnList[0].fixed"
              :class-name="fixedColumnList[0].selected ? 'cellSelected' : ''" prop="feedingTime" label="投喂开始时间">
              <template slot-scope="scope">
                {{
                  scope.row.feedingTime && scope.row.feedingTime.slice(0, 16)
                }}
              </template>
            </el-table-column>
            <el-table-column :fixed="fixedColumnList[1].fixed"
              :class-name="fixedColumnList[1].selected ? 'cellSelected' : ''" prop="feedingEndTime" label="投喂完成时间">
              <template slot-scope="scope">
                {{
                  scope.row.feedingEndTime
                  ? scope.row.feedingEndTime.slice(0, 16)
                  : ""
                }}
              </template>
            </el-table-column>
            <el-table-column :fixed="fixedColumnList[2].fixed"
              :class-name="fixedColumnList[2].selected ? 'cellSelected' : ''" prop="baseName" label="养殖场">
            </el-table-column>
            <el-table-column :fixed="fixedColumnList[3].fixed"
              :class-name="fixedColumnList[3].selected ? 'cellSelected' : ''" prop="groupName" label="区域分组">
            </el-table-column>
            <el-table-column :fixed="fixedColumnList[4].fixed"
              :class-name="fixedColumnList[4].selected ? 'cellSelected' : ''" prop="boxCode" label="塘口单元">
            </el-table-column>
            <el-table-column :fixed="fixedColumnList[5].fixed"
              :class-name="fixedColumnList[5].selected ? 'cellSelected' : ''" prop="mealsNum" label="餐数">
            </el-table-column>
            <el-table-column :fixed="fixedColumnList[6].fixed"
              :class-name="fixedColumnList[6].selected ? 'cellSelected' : ''" prop="categoryName" label="饲料品类">
            </el-table-column>
            <el-table-column :fixed="fixedColumnList[7].fixed"
              :class-name="fixedColumnList[7].selected ? 'cellSelected' : ''" prop="fodderDataName" label="饲料名称">
            </el-table-column>
            <el-table-column prop="feedingNumber" :label="'投喂量/' + fodderKgToJin">
            </el-table-column>
            <el-table-column prop="putMoney" label="金额/元"> </el-table-column>
            <el-table-column prop="statusName" label="记录状态">
            </el-table-column>
            <el-table-column prop="remark" label="备注"> </el-table-column>
          </el-table>
          <!-- 分页 -->
          <div class="uyu-pagination">
            <MyPagination @change="handleCurrentChange($event)" @changeSizes="handleSizeChange($event)"
              :sizes="[13, 26, 39, 50, 100, 200]" :pageNo.sync="pageNo" :pageSize.sync="pageSize"
              :totalCount="totalCount">
            </MyPagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FileUpload from "@/components/pc/file-upload.vue";
import MyPagination from "@/components/pc/my-pagination.vue";
import Page from "@/utils/methods/page";
import * as $echarts from "echarts";
import debounce from "../../../../../utils/debounce";
import { listParamStatus } from "@/api/general.js";
import {
  getListByPages,
  exportByFodderFeeding,
  queryBaseGroupList,
  getListByType,
  getBaseListsByUser,
  getFodders,
  getTotalType,
  listDataPermissionBoxData,
  getOptionsData,
  downloadTemplate,
  fileupload,
} from "./ym-feed-services";
export default {
  name: "day-ym-feed-feeding",
  data() {
    return {
      PageDisplay: true, // 展开收起
      orgName: "",
      // 分页列表
      pagelist: {},
      pageNo: 1,
      pageSize: 13,
      totalCount: 0,
      tableHeight: 0, // 表格高度
      fixedColumn: {},
      fixedColumnList: [
        {
          prop: "feedingTime",
          fixed: false,
          selected: false
        },
        {
          prop: "feedingEndTime",
          fixed: false,
          selected: false
        },
        {
          prop: "baseName",
          fixed: false,
          selected: false
        },
        {
          prop: "groupName",
          fixed: false,
          selected: false
        },
        {
          prop: "boxCode",
          fixed: false,
          selected: false
        },
        {
          prop: "mealsNum",
          fixed: false,
          selected: false
        },
        {
          prop: "categoryName",
          fixed: false,
          selected: false
        },
        {
          prop: "fodderDataName",
          fixed: false,
          selected: false
        },
      ],
      // 分页参数
      params: {
        currPage: 1,
        pageSize: 13,
        orderBy: "desc",
        orderByName: "feedingTime",
        params: {
          orgId: "",
          baseId: "",
          groupId: "",
          boxId: "",
          startTime: "",
          endTime: "",
          type: "", // 0 数量, 1 金额, 2 品类
          status: "",
          categoryId: "", // 饲料品类
          groupType: "", // 汇总类型
          fodderCategoryId: "",
          fodderId: "", // 饲料名称id
        },
      },
      baseList: [],
      groupList: [],
      boxList: [],
      groupTypeList: [], // 汇总类型列表
      categoryList: [], // 饲料品类列表
      reviewStatusList: [
        {
          id: 0,
          name: "草稿",
        },
        {
          id: 1,
          name: "待审核",
        },
        {
          id: 2,
          name: "已审核",
        },
      ],
      dateRange: [],
      exportParams: {}, // 导出参数
      showStatistical: false, // 是否展示统计折线图
      isNumberChart: "0", // 是否数量图表 0 | 1 | 2
      typeColors: [
        "#5574FA",
        "#F553FB",
        "#4EDDB6",
        "#2BCCFA",
        "#AE53FB",
        "#4297FF",
        "#98DD4E",
        "#FAA02B",
        "#FF427C",
        "#DCD400",
        "#7CD82A",
        "#FBDC09",
        "#97A9F7",
        "#FB92FF",
        "#84EFD2",
        "#8CE5FE",
        "#C78BFB",
        "#7DB6FC",
        "#B0E874",
        "#F8BE72",
        "#F79BB7",
        "#EBE535",
        "#ADEA76",
        "#FFE84B",
      ],
      feedstuffFeedingList: [], // 投喂数据列表
      fodderList: [], // 饲料名称列表
      legendNames: [], // 柱状图legend名称
      statisticsOpt: null,
      barInstance: null,
      allFodderData: [],
      hintFodderData: [], // 提示的饲料信息列表
      showFodderData: [], // 显示的饲料信息列表
      animationDuration: 6000, //
      fileupload: "",
      fodderKgToJin: 'kg'   // 是否把公斤转换成斤
    };
  },
  computed: {},
  methods: {
    // 查询
    search() {
      this.params.currPage = 1;
      this.params.params.type = this.isNumberChart || "0";
      this.getEchartsData();
      this.getPageList();
    },
    // 重置
    reset() {
      this.isNumberChart = "0";
      this.params.params.baseId = this.baseList[0].id;
      this.getGroups(this.params.params.baseId);
      this.params.params.boxId = "";
      this.initTime();
      this.params.params.type = this.isNumberChart;
      this.params.params.status = "";
      this.params.params.categoryId = "";
      this.params.params.groupType = "";
      this.params.params.fodderCategoryId = "";
      this.params.params.fodderId = "";
      this.params.currPage = 1;
      this.params.pageSize = 13;
      this.getEchartsData();
      this.getPageList();
    },
    // 收起
    PageSearchClose() {
      Page.PageSearchClose(this);
    },
    // 展开
    PageSearchOn() {
      Page.PageSearchOn(this);
    },
    // 合计行高亮class赋予
    tableRowClassName({ row, rowIndex }) {
      if (row.feedingTime === "合计") {
        return "heji-row";
      }
    },
    /**
     * @Author: lishiqiao
     * @Date: 2021-07-30 10:01:25
     * @description: 改变当前分页总数
     * @param {any} event
     */
    handleSizeChange(event) {
      this.params.currPage = 1;
      this.params.pageSize = event;
      this.getPageList(this.params);
    },
    /**
     * @Author: lishiqiao
     * @Date: 2021-07-30 09:56:51
     * @description: 切换当前页
     * @param {any} event
     */
    handleCurrentChange(event) {
      this.params.currPage = event;
      this.getPageList(this.params);
    },
    // 选择日期
    dateChange(val) {
      if (!val) {
        return;
      }
      this.params.params.startTime = val[0];
      this.params.params.endTime = val[1];
    },
    // 初始化时间
    initTime() {
      this.params.params.startTime = this.$moment().format("YYYY-MM-DD");
      this.params.params.endTime = this.$moment().format("YYYY-MM-DD");
      this.dateRange.push(this.params.params.startTime);
      this.dateRange.push(this.params.params.endTime);
    },
    // 分页
    getPageList() {
      const loading = this.$loading({
        lock: true,
        text: "数据加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      getListByPages(this.params).then((data) => {
        if (data.code == "0000") {
          this.pagelist = data.data;
          this.pageNo = data.data.pageNumber;
          this.pageSize = data.data.pageSize;
          this.totalCount = data.data.totalCount;
          this.feedstuffFeedingList = this.pagelist.list;
          if (data.data.pageNumber === 1) {
            this.feedstuffFeedingList.unshift({
              feedingTime: "合计",
              feedingNumber: data.data.totalNumber.totalFeedingNumber,
              putMoney: data.data.totalNumber.totalPutMoney,
            });
            // 导出的参数 解决选择了查询条件但没有点击查询时导出数据不一致的bug
            this.exportParams = JSON.parse(JSON.stringify(this.params));
          }
        }
        loading.close();
      });
    },
    // 导出
    exportTable() {
      this.$confirm(`导出表格为excel文件，请确认！`, "操作提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      }).then(() => {
        const params = {
          titleName: "饲料投喂记录列表",
          sheetName: "列表",
          fileName: "饲料投喂记录列表",
          fileCode: "feedingRecordExport_zh",
          param: this.params,
        };

        Page.exportDatas(exportByFodderFeeding(), params);
      });
    },
    // 模板下载
    download() {
      this.$confirm(`导出表格为excel文件，请确认！`, "操作提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      }).then(() => {
        const params = {
          fileName: "饲料投喂信息模板导入",
        };
        Page.exportDatas(downloadTemplate(), params);
      });
    },
    getBases() {
      // 养殖场
      getBaseListsByUser().then((res) => {
        if (res.code == "0000") {
          this.baseList = res.data;
          this.params.params.baseId = this.baseList[0].id;
          this.getGroups();
        }
      });
    },
    // 仓库
    getGroups() {
      this.params.params.groupId = "";
      this.params.params.baseId &&
        queryBaseGroupList(this.params.params.baseId).then((res) => {
          if (res.code == "0000") {
            this.groupList = res.data;
            this.getBoxs();
          }
        });
    },
    // 塘口
    getBoxs() {
      this.params.params.boxId = "";
      this.params.params.groupId &&
        listDataPermissionBoxData(this.params.params.groupId).then((res) => {
          if (res.code == "0000") {
            this.boxList = res.data;
          }
        });
    },
    // 获取echarts数据
    getEchartsData() {
      getOptionsData(this.params).then((data) => {
        if (data.code === "0000") {
          this.allFodderData = data.data.map((item, index) => {
            item.color = this.typeColors[index] || "#999999";
            if (item.categoryName) {
              item.shortName = item.categoryName;
            }
            if (!item.fodderId) {
              item.fodderId = index;
            }
            return item;
          });
          let arr = [];
          this.showFodderData =
            ((arr = this.allFodderData.slice(0, 3)),
              arr.map((re) => re.fodderId));
          this.hintFodderData = arr;
          if (this.showStatistical) {
            this.applyLine(this.hintFodderData);
          }
        }
      });
    },
    // 柱状图
    applyLine(echartsData) {
      this.barInstance && this.barInstance.clear();
      this.barInstance = new $echarts.init(
        document.getElementById("fodder-charts")
      );
      if (echartsData.length) {
        const option = {
          color: echartsData.map((item) => item.color),
          tooltip: {
            trigger: "axis",
            backgroundColor: "#ffffff",
            padding: 12,
            textStyle: {
              fontSize: "12px",
              lineHeight: "22px",
              color: "#333333",
            },
            extraCssText: "box-shadow: 0px 0px 7px 0px #E0E0E0;",
          },
          grid: {
            top: "3%",
            left: "5%",
            right: "2%",
            bottom: "25px",
          },
          xAxis: [
            {
              type: "category",
              name: "",
              data: echartsData[0].dataList.map((item) => item.time),
              axisLine: {
                lineStyle: {
                  type: "solid",
                  color: "#DEE4E6",
                },
              },
              nameTextStyle: {
                color: "#666666",
                fontFamily: "ArialMT",
                fontWeight: "400",
              },
              axisLabel: {
                color: "#666666",
                fontFamily: "ArialMT",
                fontWeight: "400",
              },
            },
          ],
          yAxis: [
            {
              type: "value",
              name: "",
              splitNumber: 6, // 指定坐标轴节点分割数（非强制），会按照预算自行调整最合适的分割数
              axisLine: {
                show: false,
              },
              axisTick: {
                show: false,
              },
              splitLine: {
                lineStyle: {
                  type: "dashed",
                  color: "#DEE4E6",
                },
              },
              nameTextStyle: {
                color: "#666666",
                fontFamily: "ArialMT",
                fontWeight: "400",
              },
              axisLabel: {
                color: "#666666",
                fontFamily: "ArialMT",
                fontWeight: "400",
              },
            },
          ],
          series: echartsData.map((item) => {
            return {
              name: item.shortName,
              type: "line",
              itemStyle: {
                normal: {
                  lineStyle: {
                    width: 1,
                    color: item.color,
                  },
                },
              },
              data: item.dataList.map((item2) => item2.num),
            };
          }),
        };
        this.barInstance.setOption(option, this.animationDuration);
      }
    },
    selectFodder() {
      let showdata = [];
      this.hintFodderData =
        ((showdata = this.allFodderData.filter((re) =>
          this.showFodderData.includes(re.fodderId)
        )),
          showdata.slice(0, 3));
      this.applyLine(showdata);
    },
    toggleChartBtn(flag) {
      this.isNumberChart = flag;
      this.params.params.type = flag;
      this.getEchartsData(this.params);
    },

    // 选中列
    handleClick(column, event) {
      this.fixedColumnList.forEach((item, i) => {
        if (JSON.stringify(this.fixedColumnList).includes(column.property)) {
          if (item.prop === column.property) {
            item.selected = !item.selected;
            if (item.selected) {
              this.fixedColumn = column;
              this.fixedColumn.idx = i;
            } else {
              this.fixedColumn = {};
            }
          } else {
            item.selected = false;
          }
        }
      });
    },

    // 设置冻结列
    setFixedColumn(command) {
      if (command === 'y') {
        if (JSON.stringify(this.fixedColumn) === "{}") {
          this.$message('请选择列');
          return;
        }
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.fixedColumnList.forEach((item, i) => {
          if (i <= this.fixedColumn.idx) {
            item.fixed = true;
          }
        })
        this.$message('已冻结至"' + this.fixedColumn.label + '"列');
        this.fixedColumn = {};
      } else if (command === 'n') {
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.$message('已取消冻结');
      }
    }
  },
  components: { MyPagination, FileUpload },
  beforeMount() {
    // 模板编译/挂载之前
  },
  mounted() {
    // 模板编译/挂载之后
    Page.pagesTableFixed(); // 表头固定
  },
  created() {
    this.tableHeight = window.innerHeight - 500;
    this.params.params.orgId = localStorage.getItem("orgId");
    // this.params.params.orgId = "7a5cfc1b-1cbe-445a-915a-d31cc9c9649e";
    this.orgName = localStorage.getItem("orgName");
    this.fileupload = fileupload();
    this.initTime();
    this.getBases();
    // 饲料
    getFodders(this.params.params.orgId).then((res) => {
      if (res.code == "0000") {
        this.fodderList = res.data;
      }
    });
    // 汇总类型
    getTotalType(this.params.params.orgId).then((res) => {
      if (res.code == "0000") {
        this.groupTypeList = res.data;
      }
    });
    // 饲料品类列表
    getListByType(this.params.params.orgId).then((res) => {
      if (res.code == "0000") {
        this.categoryList = res.data;
      }
    });
    // 获取是否公斤转换成斤
    listParamStatus(this.params.params.orgId, ['fodderKgToJin']).then((res) => {
      if (res.code == "0000") {
        this.fodderKgToJin = res.data.fodderKgToJin === true ? '斤' : 'kg';
      }
    })

    // echart自适应
    // debounce函数让一个方法在一定时间内只能执行一次
    this.resizeHandler = debounce(
      () => {
        this.barInstance && this.barInstance.resize();
      },
      100,
      false
    );
    // 监听浏览器窗口页面
    window.addEventListener("resize", this.resizeHandler);
  },
  beforeUpdate() {
    // 组件更新之前
  },
  updated() {
    // 组件更新之后
  },
  beforeDestroy() {
    // 组件销毁前调用
    // Tips：你确认删除XX吗？
  },
  destroyed() {
    // 组件销毁后调用
    // Tips：当前组件已被删除，清空相关内容
  },
  watch: {
    showStatistical(oldVal, newVal) {
      if (oldVal) {
        this.$nextTick(() => {
          this.applyLine(this.hintFodderData);
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.uyu-pagination {
  height: 100px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.navigation_tags {
  width: 100%;
  height: 83px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  >div:first-child {
    float: left;
    // margin-top: 24px;
    font-size: 14px;
    font-size: 14px;
    font-family: "MicrosoftYaHei";
    font-weight: 400;
    color: rgba(35, 38, 52, 1);

    >span {
      display: block;
      float: left;
      cursor: pointer;
      margin-right: 40px;

      &:not(:last-child) {
        position: relative;

        &::after {
          position: absolute;
          content: "";
          width: 1px;
          height: 12px;
          background-color: rgba(221, 221, 221, 1);
          top: 4px;
          right: -20px;
        }
      }
    }

    >span:last-child>button {
      float: left;
      border: none;
      outline: none;
      background-color: transparent;
      box-shadow: none;
      font-size: 14px;
      font-family: "MicrosoftYaHei";
      font-weight: 400;
      color: #abadb3;
    }

    >span:last-child>button:hover {
      border-bottom: 1px solid #abadb3;
      height: 17px;
    }
  }

  .btn_selected {
    font-size: 14px !important;
    font-family: "MicrosoftYaHei" !important;
    font-weight: bold !important;
    color: #0232ff !important;

    &:hover {
      border-bottom: 1px solid #0232ff !important;
    }
  }

  .label-type {
    position: relative;
    padding-left: 10px;

    &::after {
      content: "";
      position: absolute;
      display: inline-block;
      width: 3px;
      height: 12px;
      background: #5574fa;
      margin-right: 10px;
      left: 0;
      top: 4px;
    }
  }
}

.chart-search-item {
  min-width: 260px;

  /deep/input {
    height: 34px !important;
    border-radius: 2px;
  }

  // 日期选择器字体图标居中
  /deep/.el-input {
    .el-input__icon {
      line-height: 34px;
    }
  }

  /deep/.el-input__inner {
    border: 1px solid #dcdfe6;
  }

  display: flex;
}

.show-charts-btn {
  cursor: pointer;
  font-size: 14px;
  color: #0232ff;

  i {
    font-size: 13px;
    display: inline-block;
    margin-left: 5px;
  }
}

.chart_text {
  font-family: "SimSun";
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #333333;
}

.chart_icon {
  display: inline-block;
  width: 9px;
  height: 9px;
  border-radius: 2px;
  margin-right: 6px;
  margin-left: 30px;
}

.charts-content {
  background-color: #fff;
  padding: 0px 34px 38px 34px;
  height: 325px;

  .charts_info {
    background-color: transparent;
    height: 242px;
    width: 100%;
  }
}

.page-list .page-list-content {
  margin-top: 0px;
}

.ufish-split-line {
  margin: 0;
  padding: 0;
  border: 0;
  border-top: 1px solid #eee;
}
</style>